/**
 * puntoCaja.types.ts — Tipos de dominio para multicaja (punto de venta / sesión).
 *
 * Desacoplado de UI y de Firebase; alineado con la API `/caja/puntos` y mocks MSW.
 */

/** Debe coincidir con `LS_PUNTO_CAJA` en mocks/helpers/cajaMulticaja.ts */
export const LS_PUNTO_CAJA_KEY = "altenot_punto_caja_id";

export interface PuntoCajaListItem {
  id: string;
  nombre: string;
  /** Alias visible editable (ej: "Juan - mañana"). No afecta identidad técnica. */
  alias?: string;
  orden: number;
  activa: boolean;
  /** True en UI si hay sesión abierta en mock (opcional) */
  sesionAbierta?: boolean;
}

export interface CajaPuntosResponse {
  puntos: PuntoCajaListItem[];
  defaultPuntoCajaId: string;
}

/** Si falla la red o no hay MSW, la UI multicaja sigue mostrando al menos un punto (APK demo). */
export const FALLBACK_PUNTOS_CAJA: PuntoCajaListItem[] = [
  { id: "pc1", nombre: "Caja principal", orden: 0, activa: true },
];
